(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $c3b10a83b523f372$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(arr);
}


function $09c9f293d010c0e1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
}


function $227c6742e0ff6f82$export$1b5e630bc3aea29f(arr) {
    return (0, $c50969dc1df61e8b$export$7e0947b5ad3404e2)(arr) || (0, $09c9f293d010c0e1$export$1eb58a6e75231000)(arr) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr) || (0, $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$2996f80ef42b8419)(this, Game);
        this.state = (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(initialState);
        this.status = Game.Status.idle;
        this.score = 0;
        this.initialState = initialState;
    }
    (0, $4fc75ccb937ab1df$export$d60067ff2358eee8)(Game, [
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                this.updateStatus();
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = Game.Status.playing;
                this.state = this.initialState.concat();
                this.createRandomTile();
                this.createRandomTile();
                this.printTiles();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.clearTheBoard();
                this.printTiles();
                this.status = Game.Status.idle;
                this.score = 0;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.status !== Game.Status.playing) return;
                this.saveState();
                var didTilesMove = false;
                for(var row = 0; row < 4; row++){
                    var didJustMerged = false;
                    for(var tile = 1; tile < 4; tile++)if (this.state[row][tile] > 0) {
                        var moveTile = 0;
                        var merge = false;
                        while(this.state[row][tile - moveTile - 1] === 0)moveTile++;
                        if (!didJustMerged && this.state[row][tile - moveTile - 1] === this.state[row][tile]) {
                            moveTile++;
                            merge = true;
                        }
                        if (moveTile > 0) {
                            if (!didJustMerged && merge) {
                                didJustMerged = true;
                                var newNumber = this.state[row][tile - moveTile] * 2;
                                this.state[row][tile - moveTile] = newNumber;
                                this.score += newNumber;
                            } else {
                                didJustMerged = false;
                                this.state[row][tile - moveTile] = this.state[row][tile];
                            }
                            this.state[row][tile] = 0;
                            didTilesMove = true;
                        }
                    }
                }
                if (didTilesMove) this.createRandomTile();
                return didTilesMove;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.status !== Game.Status.playing) return;
                this.saveState();
                var didTilesMove = false;
                for(var row = 0; row < 4; row++){
                    var didJustMerged = false;
                    for(var tile = 2; tile >= 0; tile--)if (this.state[row][tile] > 0) {
                        var moveTile = 0;
                        var merge = false;
                        while(this.state[row][tile + moveTile + 1] === 0)moveTile++;
                        if (!didJustMerged && this.state[row][tile + moveTile + 1] === this.state[row][tile]) {
                            moveTile++;
                            merge = true;
                        }
                        if (moveTile > 0) {
                            if (!didJustMerged && merge) {
                                didJustMerged = true;
                                var newNumber = this.state[row][tile + moveTile] * 2;
                                this.state[row][tile + moveTile] = newNumber;
                                this.score += newNumber;
                            } else {
                                didJustMerged = false;
                                this.state[row][tile + moveTile] = this.state[row][tile];
                            }
                            this.state[row][tile] = 0;
                            didTilesMove = true;
                        }
                    }
                }
                if (didTilesMove) this.createRandomTile();
                return didTilesMove;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.status !== Game.Status.playing) return;
                this.saveState();
                var didTilesMove = false;
                for(var column = 0; column < 4; column++){
                    var didJustMerged = false;
                    for(var tile = 1; tile < 4; tile++)if (this.state[tile][column] > 0) {
                        var moveTile = 0;
                        var merge = false;
                        while(tile - moveTile - 1 >= 0 && this.state[tile - moveTile - 1][column] === 0)moveTile++;
                        if (!didJustMerged && tile - moveTile - 1 >= 0 && this.state[tile - moveTile - 1][column] === this.state[tile][column]) {
                            moveTile++;
                            merge = true;
                        }
                        if (moveTile > 0) {
                            if (!didJustMerged && merge) {
                                didJustMerged = true;
                                var newNumber = this.state[tile - moveTile][column] * 2;
                                this.state[tile - moveTile][column] = newNumber;
                                this.score += newNumber;
                            } else {
                                didJustMerged = false;
                                this.state[tile - moveTile][column] = this.state[tile][column];
                            }
                            this.state[tile][column] = 0;
                            didTilesMove = true;
                        }
                    }
                }
                if (didTilesMove) this.createRandomTile();
                return didTilesMove;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.status !== Game.Status.playing) return;
                this.saveState();
                var didTilesMove = false;
                for(var column = 0; column < 4; column++){
                    var didJustMerged = false;
                    for(var tile = 2; tile >= 0; tile--)if (this.state[tile][column] > 0) {
                        var moveTile = 0;
                        var merge = false;
                        while(tile + moveTile + 1 < this.state.length && this.state[tile + moveTile + 1][column] === 0)moveTile++;
                        if (!didJustMerged && tile + moveTile + 1 < this.state.length && this.state[tile + moveTile + 1][column] === this.state[tile][column]) {
                            moveTile++;
                            merge = true;
                        }
                        if (moveTile > 0) {
                            if (!didJustMerged && merge) {
                                didJustMerged = true;
                                var newNumber = this.state[tile + moveTile][column] * 2;
                                this.state[tile + moveTile][column] = newNumber;
                                this.score += newNumber;
                            } else {
                                didJustMerged = false;
                                this.state[tile + moveTile][column] = this.state[tile][column];
                            }
                            this.state[tile][column] = 0;
                            didTilesMove = true;
                        }
                    }
                }
                if (didTilesMove) this.createRandomTile();
                return didTilesMove;
            }
        },
        {
            key: "saveState",
            value: function saveState() {
                return this.state.map(function(row) {
                    return row.slice();
                });
            }
        },
        {
            key: "createRandomTile",
            value: function createRandomTile() {
                var row = this.randomNumber(3);
                while(!this.state[row].includes(0))row = this.randomNumber(3);
                var cell = this.randomNumber(3);
                while(this.state[row][cell] !== 0)cell = this.randomNumber(3);
                var newState = this.state.map(function(currentRow) {
                    return currentRow.slice();
                });
                newState[row][cell] = this.generateCellValue();
                this.state = newState;
                this.printTiles();
            }
        },
        {
            key: "randomNumber",
            value: function randomNumber(max) {
                return Math.round(Math.random() * max);
            }
        },
        {
            key: "generateCellValue",
            value: function generateCellValue() {
                var result = Math.random();
                return result > 0.9 ? 4 : 2;
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                if (this.didPlayerWin()) this.status = Game.Status.win;
                else if (this.didPlayerLose()) this.status = Game.Status.lose;
            }
        },
        {
            key: "didPlayerWin",
            value: function didPlayerWin() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.state.flat()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tile = _step.value;
                        if (tile === 2048) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "didPlayerLose",
            value: function didPlayerLose() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.state.flat()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var tile = _step.value;
                        if (tile === 0) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                for(var row = 0; row <= 3; row++)for(var tile1 = 0; tile1 <= 2; tile1++){
                    if (this.state[row][tile1] === this.state[row][tile1 + 1]) return false;
                }
                for(var column = 0; column <= 3; column++)for(var tile2 = 0; tile2 <= 2; tile2++){
                    if (this.state[tile2][column] === this.state[tile2 + 1][column]) return false;
                }
                return true;
            }
        },
        {
            key: "printTiles",
            value: function printTiles() {
                var cells = document.getElementsByClassName("field-cell");
                var flatState = this.state.flat();
                for(var i = 0; i < flatState.length; i++){
                    var currentCell = cells[i];
                    var currentState = flatState[i];
                    if (currentState > 0) {
                        if (currentCell !== undefined) {
                            currentCell.textContent = currentState;
                            currentCell.className = "field-cell field-cell--".concat(currentState);
                        }
                    } else if (currentCell !== undefined) {
                        currentCell.textContent = "";
                        currentCell.className = "field-cell";
                    }
                }
            }
        },
        {
            key: "clearTheBoard",
            value: function clearTheBoard() {
                this.state = this.initialState.concat();
            }
        }
    ]);
    return Game;
}();
(0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)($3d28d7f1aac198f5$var$Game, "Status", {
    idle: "idle",
    playing: "playing",
    win: "win",
    lose: "lose"
});
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startBtn = document.querySelector(".start");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
$197cd56b15c33885$var$initialize();
function $197cd56b15c33885$var$initialize() {
    $197cd56b15c33885$var$startBtn.addEventListener("click", function() {
        if ($197cd56b15c33885$var$startBtn.classList.contains("start")) {
            $197cd56b15c33885$var$startBtn.className = "button restart";
            $197cd56b15c33885$var$startBtn.textContent = "Restart";
            $197cd56b15c33885$var$startMessage.classList.add("hidden");
            $197cd56b15c33885$var$game.start();
        } else {
            $197cd56b15c33885$var$startBtn.className = "button start";
            $197cd56b15c33885$var$startBtn.textContent = "Start";
            $197cd56b15c33885$var$startMessage.classList.remove("hidden");
            $197cd56b15c33885$var$winMessage.classList.add("hidden");
            $197cd56b15c33885$var$loseMessage.classList.add("hidden");
            $197cd56b15c33885$var$score.textContent = "0";
            document.removeEventListener("keydown", $197cd56b15c33885$var$handleKeyDown);
            $197cd56b15c33885$var$game.restart();
        }
        document.addEventListener("keydown", $197cd56b15c33885$var$handleKeyDown);
    });
}
function $197cd56b15c33885$var$handleKeyDown(keyEvent) {
    keyEvent.preventDefault();
    var numbersMove = false;
    switch(keyEvent.key){
        case "ArrowUp":
            numbersMove = $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            numbersMove = $197cd56b15c33885$var$game.moveDown();
            break;
        case "ArrowRight":
            numbersMove = $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowLeft":
            numbersMove = $197cd56b15c33885$var$game.moveLeft();
            break;
    }
    if (numbersMove) {
        $197cd56b15c33885$var$updateScore($197cd56b15c33885$var$game.getScore());
        var newStatus = $197cd56b15c33885$var$game.getStatus();
        if (newStatus === $3d28d7f1aac198f5$exports.Status.lose) $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
        else if (newStatus === $3d28d7f1aac198f5$exports.Status.win) $197cd56b15c33885$var$winMessage.classList.remove("hidden");
    }
}
function $197cd56b15c33885$var$updateScore(newScore) {
    $197cd56b15c33885$var$score.textContent = newScore;
}

})();
//# sourceMappingURL=index.f6dc92ce.js.map
